import { apiClient } from '@/shared/services/http/http.service'
import { SURVEY_ENDPOINTS } from '../constants/endpoints.constant.js'

export async function publishSurvey(versionUuid) {
  const url = SURVEY_ENDPOINTS.PUBLISH.replace(':versionUuid', versionUuid)
  const response = await apiClient('generic-survey').post(url)
  if (response.data?.success === false) {
    throw new Error(response.data.error ?? 'Publish failed')
  }
  return response.data.data
}
